import { c as _c } from "react/compiler-runtime";
import { Card } from '@onefootprint/ui';
import type React from 'react';
import { CardTitle } from '@/components/entity-onboarding-details';
type ListProps = {
  title: string;
  children: React.ReactNode;
};
const List = t0 => {
  const $ = _c(8);
  const {
    title,
    children
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <CardTitle title={title} />;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== title) {
    t2 = <Card.Body className="flex-1 py-1.5"><ul aria-label={title}>{children}</ul></Card.Body>;
    $[2] = children;
    $[3] = title;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <Card.Root className="flex flex-col">{t1}{t2}</Card.Root>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default List;